import { render, staticRenderFns } from "./MainScrollable.vue?vue&type=template&id=151eb797&"
import script from "./MainScrollable.vue?vue&type=script&lang=js&"
export * from "./MainScrollable.vue?vue&type=script&lang=js&"
import style0 from "./MainScrollable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports